<template>
    <div>
        <div>
            <b-button
                :variant="`outline-${colorVariant}`"
                class="button-input"
                :pressed="active"
                block
                @click="handleClick"
            >
                <div class="d-flex align-items-center">
                    <div
                        class="d-flex align-items-center button-input__radio"
                        :class="buttonClass.radio"
                    >
                        <div
                            v-if="active"
                            class="button-input__radio-dot" 
                            :class="buttonClass.dot"
                        >
                        </div>
                    </div>
                    <slot />
                </div>
            </b-button>
        </div>
    </div>
</template>
<script>
import colorVariantMixin from '@/components/mixins/colorVariantMixin'

export default {
    name: 'inputButton',
    mixins: [colorVariantMixin],
    props: {
        active: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        buttonClass() {
            return {
                radio: this.active ? `border-${this.colorVariant}` : 'border-bq-grey-1',
                dot: this.active ? `bg-${this.colorVariant}` : ''
            }
        }
    },
    methods: {
        handleClick() {
            this.$emit('click')
        }
    }
}
</script>
<style lang="scss">
    .button-input {
        min-height: 3rem;
        font-size: 0.9rem;
        text-align: left;
        @media screen and (min-width: 450px) {
            font-size: 1rem;
        }
    }

    .button-input__radio {
        height: 20px;
        width: 20px;
        min-width: 20px;
        min-height: 20px;
        border-radius: 50%;
        border: 2px solid;
        margin: 0 1.75rem 0 1rem;
        @media screen and (min-width: 992px) {
            margin: 0 2.75rem 0 1.825rem;
        }
    }

    .button-input__radio-dot {
        height: 8px;
        width: 8px;
        min-width: 8px;
        min-height: 8px;
        border-radius: 50%;
        margin: 0 auto;
    }
</style>